import { render, staticRenderFns } from "./StagingDashboard.vue?vue&type=template&id=8ae2cb82&scoped=true"
import script from "./StagingDashboard.vue?vue&type=script&lang=js"
export * from "./StagingDashboard.vue?vue&type=script&lang=js"
import style0 from "./StagingDashboard.vue?vue&type=style&index=0&id=8ae2cb82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae2cb82",
  null
  
)

export default component.exports